/*
  * GTM datalayer helper
  * Push events to datalayer
*/

const DATALAYER_CACHE = 'datalayerEventCache'

const gtmEvent = (eventObj, fireOnce = false) => {
  // Create event cache to window
  if (typeof window?.[DATALAYER_CACHE] === 'undefined' || !window[DATALAYER_CACHE] ) {
    window[DATALAYER_CACHE] = {}
  }
  const cache = window[DATALAYER_CACHE]
  const eventKey = eventObj['event'] || false
  if (eventKey in cache && fireOnce) {
    return
  }

  // Save datalayer event to window cache
  if ( eventKey ) {
    cache[eventKey] = true
  }

  const modeProd = process.env.NODE_ENV !== 'development'

  if ( !modeProd ) {
    console.log(`GTM event in development ${JSON.stringify(eventObj)}`)
    return
  }

  if ('dataLayer' in window ) {
    window.dataLayer.push(eventObj);
  } else {
    console.warn('No datalayer found')
  }
}

export default gtmEvent
